'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTheme } from 'next-themes';
import { LocaleSelector } from '@/components/common/locale-selector';
import { ThemeSelector } from '@/components/common/theme-selector';
import { useMounted } from '@/hooks/use-mounted';
import { useIsScrolled } from '@/hooks/use-scroll-position';
import { Link, usePathname } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
interface PublicHeaderProps {
  className?: string;
  userId?: string;
}
export function PublicHeader(t0) {
  const $ = _c(16);
  const {
    className,
    userId
  } = t0;
  const isScrolled = useIsScrolled();
  const {
    resolvedTheme
  } = useTheme();
  const {
    isMounted
  } = useMounted();
  const currentTheme = isMounted ? resolvedTheme : "light";
  const pathname = usePathname();
  const isPlayground = pathname === "/playground";
  const t1 = isScrolled && !isPlayground ? "border-b" : "";
  const t2 = isPlayground && "border-b";
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = cn("sticky top-0 flex items-center justify-between gap-2 bg-background/20 px-4 py-2 backdrop-blur-sm transition-[border-color] duration-200", t1, t2, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== currentTheme || $[5] !== isMounted) {
    t4 = <Link href="/" className="shrink-0 font-semibold text-xl">{!isMounted ? <div className="h-7 w-24" /> : currentTheme === "light" ? <Image src="/qiroasro-web-logo-light.png" alt="Qiroasro Logo" width={96} height={28} priority={true} fetchPriority="high" /> : <Image src="/qiroasro-web-logo-dark.png" alt="Qiroasro Logo" width={96} height={28} priority={true} fetchPriority="high" />}</Link>;
    $[4] = currentTheme;
    $[5] = isMounted;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== userId) {
    t5 = <LocaleSelector userId={userId} />;
    $[7] = userId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ThemeSelector />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <div className="flex items-center gap-2">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t7) {
    t8 = <header className={t3}>{t4}{t7}</header>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}